import React, { useState, useEffect } from "react";
import Appbar from "./Appbar";
import Musiclist from "./Musiclist";
import Searchbar from "./Searchbar";
import { useProvider } from "./StateProvider";

const Dashboard = () => {
  const [songlist, setSonglist] = useState([]);
  const [filteredList, setFilteredList] = useState([]);

  const { db } = useProvider();

  useEffect(() => {
    const unsub = db.collection("songs").onSnapshot((snap) => {
      const list = [];
      snap.forEach((doc) => {
        list.push({ ...doc.data(), id: doc.id });
      });
      setSonglist(list);
      setFilteredList(list);
    });
    return unsub;
  }, [db]);

  return (
    <>
      <Appbar />
      <Searchbar songList={songlist} setFilteredList={setFilteredList} />
      <Musiclist songlist={filteredList} />
    </>
  );
};

export default Dashboard;
